import React, {Component} from 'react';
import loader from  '../assets/image/half-circle.gif';
import PdfIcon from  '../assets/image/img-pdf-icon.png';
import ReactModal from 'react-modal';
import { withTranslation } from 'react-i18next';

var modalId = [];
class MyCertification extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showModal: false
        }
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    handleOpenModal (e, id) {
        modalId = this.props.certficates && this.props.certficates.filter((c, i) => id === i);
        if(modalId.length >0) {
            this.setState({ showModal: true });
        }
    }
      
    handleCloseModal () {
        modalId = [];
        this.setState({ showModal: false });
    }
    
    render(){
        const { certficates, loading, dataNotFound, t } = this.props;
        const { showModal } = this.state;
        return(
            <div className="card" id="myCertifications">
                <div className="card-header">
                    <h3 className="card-header-title">{t('My Certifications')}</h3>
                </div>
                <div className="card-body card-body-image-list">
                {loading ? 
                    <div className="card-loader">
                        <img src={loader} alt="loading..." />
                    </div>
                    :
                    dataNotFound?
                    <div className="card-loader">
                        {t('Data not found')}
                    </div>   
                    :
                    certficates && certficates.length >0 ?
                    <div className="card-list">
                    {certficates && certficates.map((c, i) => {
                        return(
                        <div key={i} className="card-item">
                            <div className="card-item-image">
                                {c.url && c.url.split('.').pop() === 'pdf' ? 
                                <img src={PdfIcon} alt="certificate"
                                onClick={() => {
                                    window.open(c.url, "_blank");
                                  }}
                                />
                                :c.url?
                                <img src={c.url} alt="certificate" 
                                onClick={e => this.handleOpenModal(e, i)}
                                />
                              :null }
                            </div>
                            <div className="card-item-content">
                                <h5 className="card-item-title">{c.caption}</h5>
                                <p className="card-item-info">{c.year}</p>
                            </div>
                        </div>
                        )
                    })
                    }
                    </div>
                    :
                    <div className="card-loader">
                        {t('Data not found')}
                    </div>
                }
                </div>
                <ReactModal 
                    isOpen={showModal}
                    contentLabel="Minimal Modal Example"
                    className="Modal modal-preview"
                    overlayClassName="Overlay"
                    onRequestClose={this.handleCloseModal}
                    >
                    {modalId && modalId.map((c, i) => {
                    return(
                        <img src={c.url} alt="certificate" className="card-item-image-preview"/>
                        )
                    })
                }
                <button onClick={this.handleCloseModal} className="modal-close"> <i className="fa fa-close"></i> </button>
                </ReactModal>
            </div>
        )
    }
}

export default withTranslation()(MyCertification);